import { Component, Input } from "@angular/core";
import { ErrorComponentBase } from "../error.decorator";
import { IMenu } from "app/types/menu";

export interface ErrorOopsPageComponent extends ErrorComponentBase { }
@Component({
    selector: "error-oops-page-component",
    templateUrl: "../error.view.html",
    standalone: false
})
@ErrorComponentBase
export class ErrorOopsPageComponent {

  @Input() error: { [key: string]: any };
  @Input() home: IMenu = null;
  @Input() sections: IMenu[] = [];

  code: string = 'Oops!';
  subTitle: string = "";
  lead: string = `There seems to be an error on our end. Try one of these links to get back on track.`

}
